const NON_ORG_HOSTS = ['ruby4', 'www', 'app', 'dev', 'localhost', 'gix'];

export function getSubdomainFromHost(hostname) {
  if (!hostname) return null;

  const host = hostname.split(':')[0];
  const parts = host.split('.');

  if (parts.length < 3) return null;

  const subdomain = parts[0];

  if (NON_ORG_HOSTS.includes(subdomain)) return null;

  return subdomain;
}

export function findOrgBySubdomain(orgs, subdomain) {
  if (!subdomain) return null;
  return (
    (orgs || []).find((org) => org.subdomain === subdomain) ||
    (orgs || []).find((org) => org.alt_subdomain === subdomain) ||
    null
  );
}

export function resolveCurrentOrg(orgs, sessionOrg) {
  if (sessionOrg) return sessionOrg; // usuário logado: usa current_org da sessão
  const subdomain = getSubdomainFromHost(window.location.hostname);
  return findOrgBySubdomain(orgs, subdomain);
}